import { Column, Table } from '@tanstack/react-table'
import { createContext, useContext } from 'react'

export const NomTableContext = createContext<{ tableInstance: Table<{}> } | null>(null)

export const useNomTableContext = (): { tableInstance: Table<{}> } => {
  const context = useContext(NomTableContext)

  if (context === null) {
    throw new Error('Table context has not been initialised. Are you executing this hook outside of <NomTable>?')
  }

  return context
}

export const NomColumnContext = createContext<Column<{}, unknown> | null>(null)

export const useNomColumnContext = (): Column<{}, unknown> => {
  const context = useContext(NomColumnContext)

  if (context === null) {
    throw new Error('Column context has not been initialised. Are you executing this hook outside of <NomTableFilters>?')
  }

  return context
}
